function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6B7081",
  d: "M2.105 0C.947 0 0 .94 0 2.09v14.637h2.105V2.091h12.632V0H2.105zm4.21 4.182c-1.157 0-2.104.94-2.104 2.09V20.91c0 1.15.947 2.091 2.105 2.091h11.579C19.053 23 20 22.06 20 20.91V9.41l-5.263-5.228H6.316zm0 2.09h7.37v4.183h4.21v10.454H6.315V6.273zm2.106 6.273v2.091h7.368v-2.09H8.421zm0 4.182v2.091h7.368v-2.09H8.421z"
});

var SvgFormFile = function SvgFormFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFormFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/formFile.4247cc9b.svg";
export { ForwardRef as ReactComponent };